import { useRef } from "react"

import { HelpCenterContent, HelpCenterHeader, WikiSection } from "@/areas/help-center"
import Article from "@/shared/layouts/Article/Article"

function HelpCenterOverview() {
  const contentRef = useRef<HTMLDivElement>(null)

  return (
    <HelpCenterContent ref={contentRef}>
      <HelpCenterHeader
        title="Help Center"
        subtitle="Welcome to the Stream OCB Help Center. Find guides and documentation for all features."
        contentRef={contentRef}
      />

      <WikiSection id="under-construction" title="Under Construction">
        <Article>
          <p>
            This help center is currently under construction. Please check back soon for updates.
          </p>
        </Article>
      </WikiSection>
    </HelpCenterContent>
  )
}

export default HelpCenterOverview
